import React from 'react'
import withIcon from '@/components/withIcon'

type TProps = {
  className?: string
}

function IconInsuranceAccepted({ className }: TProps) {
  return (
    <svg
      className={className ?? ''}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#u-1741797152962)">
        <path
          d="M15.637 2.162 8.137.02a.491.491 0 0 0-.274 0l-7.5 2.142a.5.5 0 0 0-.363.48c0 10.41 7.753 13.3 7.832 13.329a.5.5 0 0 0 .336 0C8.247 15.942 16 13.052 16 2.641a.5.5 0 0 0-.363-.48Z"
          fill="currentColor"
        />
        <path
          d="M11.528 4.47a.749.749 0 0 0-1.06 0l-3.47 4.468-1.47-1.469a.751.751 0 0 0-1.1 1.023l.037.037 2 2a.75.75 0 0 0 1.058 0l4-5a.75.75 0 0 0 0-1.06h.005Z"
          fill="#fff"
        />
      </g>
      <defs>
        <clipPath id="u-1741797152962">
          <path
            fill="#fff"
            d="M0 0h16v16H0z"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default withIcon(IconInsuranceAccepted)
